import { makeAutoObservable } from "mobx"
import { getStockDetailData, getStockDetailDataSSE } from "../../../modules/quote/web"
import { getPageType, PageType } from "../../shared/pagetype"
import { ChartType } from "../../shared/utils"

class Store {
  constructor() {
    if (getPageType() == PageType.外汇) {
      makeAutoObservable(this)
      this.init()
    }
  }

  StockDetail: any = undefined

  chartType = ChartType.分时

  chart_mouse_move_data: any = null

  async init() {
    this.getData()
  }

  getData() {
    getStockDetailDataSSE(window.quotedata.quotecode, "f19,f39,f43,f44,f45,f46,f47,f48,f50,f57,f58,f59,f60,f107,f116,f117,f120,f121,f122,f152,f162,f164,f168,f169,f170,f171,f177,f291,f292,f532", (data:any)=>{
      this.setStockDetail(data)
    })
  }

  setStockDetail(StockDetail: any) {
    this.StockDetail = StockDetail
  }

  setChartType(chartType: ChartType) {
    this.chartType = chartType
  }

  setChartMouseMoveData(chart_mouse_move_data: any) {
    this.chart_mouse_move_data = chart_mouse_move_data
  }
}

export const store = new Store()
